import React from "react";
import { productSingleTranslations, languages } from "utils/constants";
import Tabs from "components/tabs";

const Nutritions = ({ data, title, lang }) => {
	const { nutritionPer100: hundred, nutritionPerPortion: portion } = data ?? "";

	const rows = ["energy", "fat", "fattyAcids", "carbohydrates", "ofWhichSuggar", "dietaryFiber", "protein", "salt"];

	return (
		<>
			<h2 className="my-4">{title}</h2>
			<table className="text-[#757575] w-full">
				<thead>
					<tr>
						<th className="text-left">
							<strong>{productSingleTranslations[lang]?.typicalValues}</strong>
						</th>
						<th className="text-left">
							<strong>{hundred?.weight}</strong>
						</th>
						<th className="text-left">
							<strong>{portion?.weight}</strong>
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((r, i) =>
						<tr key={i}>
							<td>{Object.hasOwn(productSingleTranslations[lang], r) && productSingleTranslations[lang][r]}</td>
							<td>{Object.hasOwn(hundred ?? {}, r) && hundred[r]}</td>
							<td>{Object.hasOwn(portion ?? {}, r) && portion[r]}</td>
						</tr>
					)}
				</tbody>
			</table>
		</>
	);
};

const NutritionsTab = ({ data }) => {
	const tabs = languages.map(lang => ({
		label: lang,
		content: data.product.details.products.map((p, i) =>
			<Nutritions key={i} data={p.inBundleDetails} title={p?.title} lang={lang} />)
	}));
	return <Tabs tabs={[...tabs]} />;
};

export default NutritionsTab;
